import React from "react";
import "./styles/our_products.css";

const OurProducts = () => {
  return (
    <div className="products-container">
      <h1 className="section-title">Our Products</h1>

      {/* Cakes & Pastries Section */}
      <div className="product-category">
        <h2>Cakes & Pastries</h2>
        <ul>
          <li>Tutti Frutti Bread Cake</li>
          <li>Chocolate Bread Cake</li>
          <li>Cake Rusk</li>
          <li>Chocolate Truffle, Red Velvet, Ras Malai Cakes</li>
        </ul>
      </div>

      {/* Cookies & Biscuits Section */}
      <div className="product-category">
        <h2>Cookies & Biscuits</h2>
        <ul>
          <li>Butter Cookies</li>
          <li>Fariyali Cookies</li>
          <li>Swiss Rolls, Donuts, and Jam Rolls</li>
        </ul>
      </div>

      {/* Savory Bakes & Fast Food Section */}
      <div className="product-category">
        <h2>Savory Bakes & Fast Food</h2>
        <ul>
          <li>Pizza, Burgers, and Sandwiches</li>
          <li>Baked Samosa and Mini Toast</li>
        </ul>
      </div>

      {/* Snacks & Namkeen Section */}
      <div className="product-category">
        <h2>Snacks & Namkeen</h2>
        <li>
          
             We offer a selection of crispy and
            flavorful namkeens, perfect for all-day snacking.
          </li>
        
      </div>
    </div>
  );
};

export default OurProducts;
